/* M6 · 欢迎弹窗：5s 后弹，30 天一次，ESC/遮罩/✕ 关闭，CLAIM 复制码 */
(function () {
  'use strict';
  var KEY = 'he_welcome_seen';
  var DAYS30 = 30 * 24 * 60 * 60 * 1000;

  function seen() {
    try {
      var t = parseInt(localStorage.getItem(KEY) || '0', 10);
      return t && Date.now() - t < DAYS30;
    } catch (e) { return true; }
  }
  function markSeen() {
    try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
  }

  function init() {
    var root = document.querySelector('.he-welcome');
    if (!root || seen()) return;
    var box = root.querySelector('.he-welcome__box');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      root.hidden = false;
      requestAnimationFrame(function () { root.classList.add('is-on'); });
      box.focus();
      document.addEventListener('keydown', onKey);
    }
    function close() {
      markSeen();
      root.classList.remove('is-on');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { root.hidden = true; }, 250);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      /* a11y:Tab 焦点圈锁在弹窗内 */
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(box.querySelectorAll('button, [href], input, select, textarea'), function (el) { return !el.disabled && el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-he-welcome-close]')) close();
    });

    function showCode() {
      var emailStep = root.querySelector('[data-he-welcome-step="email"]');
      var codeStep = root.querySelector('[data-he-welcome-step="code"]');
      if (emailStep) emailStep.hidden = true;
      if (codeStep) {
        codeStep.hidden = false;
        try { codeStep.setAttribute('tabindex', '-1'); codeStep.focus(); } catch (e) {}
      }
      markSeen();
    }
    var form = root.querySelector('.he-welcome__form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var emailEl = form.querySelector('input[type="email"]');
        var email = emailEl ? emailEl.value.trim() : '';
        if (!email || (emailEl.checkValidity && !emailEl.checkValidity())) {
          if (emailEl && emailEl.reportValidity) emailEl.reportValidity();
          return;
        }
        var btn = form.querySelector('button[type="submit"]');
        if (btn) { btn.disabled = true; btn.textContent = 'Joining…'; }
        form.setAttribute('aria-busy', 'true');

        /* Klaviyo identify 是独立的 onsite 调用，不依赖 Shopify /contact 是否 302 重定向。
           先 identify → 邮箱 100% 进 Klaviyo（触发欢迎流），不被 Shopify 的 200 JSON 回包 / 302 差异 / 限流静默吞掉。 */
        try {
          var props = { '$email': email, 'email': email };
          if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify(props);
          else { window._learnq = window._learnq || []; window._learnq.push(['identify', props]); }
        } catch (e2) {}
        /* Shopify customer 记录尽力落库（去掉 Accept:json，让 Shopify 走标准 302 而非 200 JSON）；
           邮箱已进 Klaviyo → 直接揭码，不再因重定向信号缺失误报“出错”丢转化。 */
        fetch(form.action, { method: 'POST', body: new FormData(form) }).catch(function () {});
        form.removeAttribute('aria-busy');
        showCode();
      });
    }

    // Defer the welcome popup until the cookie-consent banner is handled, so the two
    // overlays never stack on first load. Falls back to a plain 6s open if no banner.
    function openWhenClear(n) {
      /* cookie 横幅未处理时等待,但封顶 ~60s(原版会无限轮询) */
      if (document.querySelector('#shopify-pc__banner, .shopify-pc__banner') && (n || 0) < 24) {
        setTimeout(function () { openWhenClear((n || 0) + 1); }, 2500);
        return;
      }
      open();
    }
    setTimeout(function () { openWhenClear(0); }, 6000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
